import React, { useEffect, useState } from 'react';
import {
  useHistory,
  useLocation,
} from 'react-router-dom/cjs/react-router-dom.min';
import useHousingStockHousesState from '../../hooks/useHousingStockHousesState';
import styles from './ChangingAllPageTwo.module.scss';
import { useHouseTemplates } from '../../components/ui/HouseRegistrationTypeManager/api/templatesQuery';
import FormRegisterTwo from '../../components/ui/FormRegisterTwo/FormRegisterTwo';
import { Spin } from 'antd';
import { useSelector } from 'react-redux';
import BtnRegistration from '../../components/common/BtnRegistration/BtnRegistration';

const ChangingAllPageTwo = () => {
  const location = useLocation();
  const history = useHistory();

  const registrationTypeHouse = location.state?.registrationType;
  const activeLsTypes = location.state?.activeLsTypes;
  // const arrearProviders = location.state?.arrearProviders;

  const currentCompany = useSelector(
    (state) => state.housingStockStore.currentCompany
  );

  const {
    housingStockHousesState: { data: houses, isFetching: isHousesFetching },
  } = useHousingStockHousesState();

  const [housesData, setHousesData] = useState(null);

  useEffect(() => {
    const filteredArray = houses?.filter((item1) =>
      location.state.houses.some((item2) => item1.houseId === item2.houseId)
    );

    setHousesData(filteredArray);
  }, [houses]);

  const data = {
    companyId: currentCompany?.id,
    houseId: housesData?.length > 1 ? housesData[0].houseId : '',
    registrationType: registrationTypeHouse,
  };

  const { data: houseTemplates, isFetching } = useHouseTemplates(
    {
      serviceCompanyId: data?.companyId,
      registrationTypeId: data?.registrationType?.id,
    },
    {
      staleTime: Infinity,
      enabled: Boolean(data?.companyId && data?.registrationType),
    }
  );

  const chengeHistory = () => {
    history.push(`/HousingStock/company/${currentCompany?.id}/changingAll`, {
      houses: housesData,
    });
  };

  const cancellationCancel = () => {
    history.push(`/HousingStock/company/${currentCompany?.id}/houses`);
  };

  return (
    <Spin spinning={isHousesFetching || isFetching}>
      <div className={styles.container}>
        <header className={styles.header}>
          <div className={styles.block}>
            <h2 className={styles.title}>Изменить режим регистрации</h2>
            <p className={styles.step}>Шаг 2/2</p>
          </div>
          <BtnRegistration
            text="Отменить"
            onClick={cancellationCancel}
          />
        </header>
        <FormRegisterTwo
          activeLsTypes={activeLsTypes}
          // arrearProviders={arrearProviders}
          chengeHistory={chengeHistory}
          houseTemplates={houseTemplates}
          housesData={housesData}
          registrationTypeHouse={registrationTypeHouse}
        />
      </div>
    </Spin>
  );
};
export default ChangingAllPageTwo;
